import request from '../../../../../../setup/axios/request'

export const searchAndPagingUser = (filter: any) => {
  return request({
    url: '/api/v1/Customer/customers',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(filter),
    },
  })
}

export const getCustomerById = (id: string) => {
  return request({
    url: '/api/v1/Customer/customer-by-id/' + id,
    method: 'get',
  })
}

export const addNewUser = (data: any) => {
  return request({
    url: '/api/v1/Customer/customers',
    method: 'post',
    data: data,
  })
}

export const getDataFileUpLoadByCustomerCode = (customerCode: string) => {
  return request({
    url: '/api/v1/FileManager/get-data-file-upLoad-by-customerCode?customerCode=' + customerCode,
    method: 'get',
  })
}
///api/v1/Customer/customers
